<template>
  <range-picker
    v-model="dateRange"
    :ranges="false"
    :autoApply="true"
    :locale-data="$store.getters.monthList"
    :opens="pickerPosition()"
    class="datepicker subtitle-2 font-weight-medium"
  >
    <template slot="input" style="min-width: 220px">
      <v-layout class="ma-0 justify-space-between align-center">
        <v-flex pa-0>
          {{ showingDateRange }}
        </v-flex>
        <v-flex class="layout ma-0 pa-0 align-center justify-end">
          <icon-close
            v-if="range.startDate"
            @click.native.stop="clearInput"
            size="16"
            class="ma-0 mr-1 link"
            color="#98b3cf"
          ></icon-close>
          <icon-calendar
            class="ma-0 mt-1 link blue"
            :color="
              $store.getters.themeDark
                ? $vuetify.theme.primary
                : $vuetify.theme.theme
            "
          ></icon-calendar>
        </v-flex>
      </v-layout>
    </template>
  </range-picker>
</template>
<script>
import DateRangePicker from "vue2-daterange-picker";
import IconCalendar from "../icon/IconCalendar.vue";
import IconClose from "../icon/IconClose.vue";
import moment from "moment";
export default {
  name: "DateRangePicker",
  props: {
    // порядковый номер карточки на экране
    index: {
      default: 0,
      type: Number,
    },
    // выбранный период дат
    range: {
      default: () => ({
        startDate: null,
        endDate: null,
      }),
      type: Object,
    },
    isShowError: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    IconCalendar,
    "range-picker": DateRangePicker,
    IconClose,
  },
  computed: {
    // текущее разрешение
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    // выбранный период дат
    dateRange: {
      get() {
        return this.range;
      },
      set(value) {
        this.$emit("update", value);
      },
    },
    // отформатированный период дат
    showingDateRange() {
      return !this.range.startDate
        ? this.isShowError
          ? "Не выбран период"
          : ""
        : moment(this.range.startDate).format("L") +
            " - " +
            moment(this.range.endDate).format("L");
    },
  },
  methods: {
    // возвращает относительное положение датапикера на экране
    pickerPosition() {
      if (this.index === -1) {
        return "center";
      }
      if (this.breakpoint === "sm") {
        return this.index === 0 || this.index % 2 === 0
          ? "right"
          : (this.index + 1) % 2 === 0
          ? "left"
          : "center";
      }
      if (this.breakpoint === "md" || this.breakpoint === "lg") {
        return this.index === 0 || this.index % 3 === 0
          ? "right"
          : this.index === 2 || (this.index - 2) % 3 === 0
          ? "left"
          : "center";
      }
      return "";
    },
    // Очищает инпут календаря к исходным значениям
    clearInput() {
      this.$emit("update", { startDate: null, endDate: null });
    },
  },
};
</script>
